export class ListaNFCeContingenciaRequest {
    public pesquisarNumero: string | null;
    public pesquisarCliente: string | null;
    public idEmissor: number | null;
    public idTipoAmbiente: number | null;
    public idStatusSecundarioDocumento: number | null;
    public serie: number | null;
    public numeroInicial: number | null;
    public numeroFinal: number | null;
    public dataHoraEmissaoInicial: Date | null;
    public dataHoraEmissaoFinal: Date | null;
}
